export default __webpack_public_path__ + "static/media/about.6e7b1b51.jpg";